import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import { currencyFormat } from 'utilities/common';

let table = { ...config };

table.url = '/finance/receivable';
table.filter = { is_report: true };
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col fs-9">
          <div className="text-ellipsis fw-semibold text-uppercase">
            {row?.code}
          </div>
          <small className="info">{row?.reff_code}</small>
        </div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  customer_id: {
    title: 'Client',
    alias: 'customer.id',
    sortable: true,
    width: 150,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fw-semibold text-uppercase">
            {row?.customer.name}
          </div>
          <small className="info text-uppercase">
            {row?.customer.company_name}
          </small>
        </div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  project_id: {
    title: 'Project',
    alias: 'project.id',
    sortable: true,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fw-semibold text-uppercase">
            {row?.project?.name || '-'}
          </div>
          <small className="info text-uppercase">
            {row?.project?.type} - {row?.project?.invoice_method}
          </small>
        </div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  periode: {
    title: 'Periode',
    sortable: false,
    width: 80,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {row?.periode_project !== '0001-01-01T00:00:00Z'
            ? formatDate(row?.periode_project, 'YYYYMM')
            : '-'}
        </div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  schedule_at: {
    title: 'Date',
    sortable: false,
    width: 80,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {formatDate(row?.schedule_at, 'DD/MM/YYYY')}
        </div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  due_date: {
    title: 'Due Date',
    sortable: false,
    width: 80,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {formatDate(row?.due_at, 'DD/MM/YYYY')}
        </div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  dpp: {
    title: 'DPP',
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {currencyFormat(row?.subtotal_nett)}
        </div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  ppn: {
    title: 'PPN',
    sortable: false,
    width: 80,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <div className="text-ellipsis">{currencyFormat(row?.subtotal_tax)}</div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  total_charges: {
    title: 'Total Invoice',
    format_number: true,
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {currencyFormat(row?.total_charges)}
        </div>
      );
    },
  },

  pph_nominal: {
    title: 'PPH',
    format_number: true,
    sortable: false,
    width: 80,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {row?.pph_nominal > 0 ? `(${currencyFormat(row?.pph_nominal)})` : 0}
        </div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  total_paid: {
    title: 'Payment',
    format_number: true,
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <div className="text-ellipsis">{currencyFormat(row?.total_paid)}</div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  additional_charges: {
    title: 'Admin/Return',
    format_number: true,
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {currencyFormat(row?.additional_charges)}
        </div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },

  receivable: {
    title: 'Receivable',
    format_number: true,
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {currencyFormat(row?.total_charges - row?.total_paid)}
        </div>
      );
    },
    url: (row) => {
      return `/receivable/${row?.id}`;
    },
  },
};

export default table;
